// Constants
import { EDIT_PAYMENT_METHOD, HALF_DIVIDER } from './constants/financial-data.utils.constants';
// Types
import { ShowEditLinkType, ShowFinancialDataListContainerType } from './types/financial-data.utils.type';

const isMiddleItem = ({ index, length }: ShowFinancialDataListContainerType): boolean =>
  index === length / HALF_DIVIDER;

const isLastItem = ({ index, length }: ShowFinancialDataListContainerType): boolean => 
  index === length - 1;

const showEditLink = ({ value, editPaymentMethod }: ShowEditLinkType): boolean =>
  value === EDIT_PAYMENT_METHOD && editPaymentMethod;

export { isMiddleItem, isLastItem, showEditLink };
